import { render, staticRenderFns } from "./InvoiceLayout.vue?vue&type=template&id=0ff041ab&scoped=true&"
import script from "./InvoiceLayout.vue?vue&type=script&lang=js&"
export * from "./InvoiceLayout.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceLayout.vue?vue&type=style&index=0&id=0ff041ab&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff041ab",
  null
  
)

export default component.exports